import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Form } from "@/components/ui/form";
import { z } from "zod";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import FormInputField from "@/components/lib/from-input-field";
import useAuth from "@/hooks/useAuth";
import {
  createNewBrand,
  clearBrandMessages,
} from "@/redux/slice/essential-menu-slice/brand-slice";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-hot-toast";

export default function CreateBrandDialog({ isOpen, onClose, title, menu_id }) {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { createLoading, error } = useSelector(
    (state) => state.essentialMenu.brands
  );

  const form = useForm({
    resolver: zodResolver(schema),
    mode: "onChange",
    defaultValues: {
      name: "",
      description: "",
      status: "active",
    },
  });

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      menu_item_id: menu_id,
      client_id: user?.client_id,
      restaurant_id: user?.restaurant_id,
    };
    try {
      dispatch(clearBrandMessages());
      const res = await dispatch(createNewBrand(payload));
      if (createNewBrand.fulfilled.match(res)) {
        toast.success("Brand created successfull.");
        form.reset();
        dispatch(clearBrandMessages());
        onClose();
      } else if (createNewBrand.rejected.match(res)) {
        toast.error(error);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong.");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <div className="py-5 flex flex-col">
          <DialogTitle className="text-lg absolute top-4 font-medium">
            {title || "Create New"}
          </DialogTitle>
          <Separator className="mt-4" />

          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="flex flex-col gap-6 mt-5"
            >
              <FormInputField
                name={"name"}
                style="bg-cblack3"
                placeholder={"Name"}
                form={form}
                label={"Name"}
                type="text"
              />

              <FormInputField
                name="description"
                style="bg-cblack3"
                placeholder={"Description"}
                form={form}
                label={"Description "}
                type="textarea"
              />
              <Button
                isLoading={createLoading}
                type="submit"
                className="bg-cyellow w-full text-cblack"
              >
                Confirm
              </Button>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  );
}

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
  status: z.enum(["active", "archive", "draft"]).default("active"),
});
